import {ArtfactKind, EnvironmentKind} from '@mrp-brasil/nick-data-commons';
import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {Observable, of} from 'rxjs';
import {concatMap, map} from 'rxjs/operators';
import {HttpHook} from '../http/http.hook';
import moment from 'moment';

@HookClass('pay')
export class PayHook extends BaseHook {

    @Hook('95866102-0f69-40ef-acbe-1ec9b6fb7b14')
    public creditCard(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.make<HttpHook>(HttpHook)
            .pipe(concatMap((httpHook: HttpHook) => {
                return this.settings
                    .pipe(concatMap((settings: any) => {

                        const endpoint = settings.environment == EnvironmentKind.DEV
                            ? 'https://app.local.nickbuilder.com.br/api/process/start/new'
                            : 'https://pay.fluna.io/api/process/start/new';


                        const httpArtifact = new NickProcessArtfact();
                        httpArtifact.kind = ArtfactKind.ANY;
                        httpArtifact.object = {
                            config: {
                                url: `${endpoint}/a4d80104-2ee4-4add-af39-50b0a8330ef3`,
                                params: {},
                                headers: {
                                    'nick-system': 'c45606f4-a9c9-48cd-b63f-8c1ddca7c2f8'
                                },
                                body: inputArtifact.object.data
                            }
                        };

                        return httpHook.postExternal(httpArtifact);
                    }));
            }))
            .pipe(map((response: NickProcessArtfact) => {
                return response;
            }));
    }

    @Hook('0ba35205-a357-46f1-ac19-141220ea59c5')
    public bankSlip(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {

        return this.make<HttpHook>(HttpHook)
            .pipe(concatMap((httpHook: HttpHook) => {
                return this.settings
                    .pipe(concatMap((settings: any) => {

                        const endpoint = settings.environment == EnvironmentKind.DEV
                            ? 'https://app.local.nickbuilder.com.br/api/process/start/new'
                            : 'https://pay.fluna.io/api/process/start/new';


                        const httpArtifact = new NickProcessArtfact();
                        httpArtifact.kind = ArtfactKind.ANY;
                        httpArtifact.object = {
                            config: {
                                url: `${endpoint}/2daa1639-622a-46db-9b2b-a9f871149b40`,
                                params: {},
                                headers: {
                                    'nick-system': 'c45606f4-a9c9-48cd-b63f-8c1ddca7c2f8'
                                },
                                body: {
                                    serviceData: inputArtifact.object.serviceData,
                                    id: inputArtifact.object.id,
                                    amount: inputArtifact.object.amount,
                                    expireAt: inputArtifact.object.expireAt,
                                    paymentLimitDate: inputArtifact.object.paymentLimitDate,
                                    description: inputArtifact.object.description,
                                    instructions: inputArtifact.object.instructions,
                                    lateFee: inputArtifact.object.lateFee,
                                    fineFee: inputArtifact.object.fineFee,
                                    establishmentId: inputArtifact.object.establishmentId,
                                    ourNumber: inputArtifact.object.ourNumber,
                                    customer: {
                                        firstName: inputArtifact.object.customer.firstName,
                                        lastName: inputArtifact.object.customer.lastName,
                                        email: inputArtifact.object.customer.email,
                                        phone: inputArtifact.object.customer.phone,
                                        document: inputArtifact.object.customer.document,
                                        birthday: inputArtifact.object.customer.birthday,
                                        address: {
                                            line1: inputArtifact.object.customer.address.line1,
                                            line2: inputArtifact.object.customer.address.line2,
                                            line3: inputArtifact.object.customer.address.line3,
                                            neighborhood: inputArtifact.object.customer.address.neighborhood,
                                            city: inputArtifact.object.customer.address.city,
                                            state: inputArtifact.object.customer.address.state,
                                            postalCode: inputArtifact.object.customer.address.postalCode,
                                            countryCode: inputArtifact.object.customer.address.countryCode
                                        }
                                    }
                                }
                            }
                        };

                        return httpHook.postExternal(httpArtifact);
                    }));
            }))
            .pipe(map((response: NickProcessArtfact) => {
                return response;
            }));
    }

    @Hook('19821f19-b3c1-48a5-b1d2-25d8fdca2238')
    public cardToken(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {

        return this.make<HttpHook>(HttpHook)
            .pipe(concatMap((httpHook: HttpHook) => {
                return this.settings
                    .pipe(concatMap((settings: any) => {

                        const endpoint = settings.environment == EnvironmentKind.DEV
                            ? 'https://app.local.nickbuilder.com.br/api/process/start/new'
                            : 'https://pay.fluna.io/api/process/start/new';


                        const httpArtifact = new NickProcessArtfact();
                        httpArtifact.kind = ArtfactKind.ANY;
                        httpArtifact.object = {
                            config: {
                                url: `${endpoint}/7ca4d1d5-e479-4126-aef1-2ea994fe5300`,
                                params: {},
                                headers: {
                                    'nick-system': 'c45606f4-a9c9-48cd-b63f-8c1ddca7c2f8'
                                },
                                body: {
                                    serviceData: inputArtifact.object.serviceData,
                                    establishmentId: inputArtifact.object.establishmentId,
                                    card: {
                                        number: inputArtifact.object.card.number,
                                        holderName: inputArtifact.object.card.holderName,
                                        securityCode: inputArtifact.object.card.securityCode,
                                        expirationYear: inputArtifact.object.card.expirationYear,
                                        expirationMonth: inputArtifact.object.card.expirationMonth
                                    },
                                    customer: {
                                        firstName: inputArtifact.object.customer.firstName,
                                        lastName: inputArtifact.object.customer.lastName,
                                        email: inputArtifact.object.customer.email,
                                        phone: inputArtifact.object.customer.phone,
                                        document: inputArtifact.object.customer.document,
                                        birthday: inputArtifact.object.customer.birthday,
                                        address: {
                                            line1: inputArtifact.object.customer.address.line1,
                                            line2: inputArtifact.object.customer.address.line2,
                                            line3: inputArtifact.object.customer.address.line3,
                                            neighborhood: inputArtifact.object.customer.address.neighborhood,
                                            city: inputArtifact.object.customer.address.city,
                                            state: inputArtifact.object.customer.address.state,
                                            postalCode: inputArtifact.object.customer.address.postalCode,
                                            countryCode: inputArtifact.object.customer.address.countryCode
                                        }
                                    }
                                }
                            }
                        };

                        return httpHook.postExternal(httpArtifact);
                    }));
            }))
            .pipe(map((response: NickProcessArtfact) => {
                return response;
            }));
    }

    @Hook('c53cdfaa-b96f-4674-8221-a57af3d8ae7c')
    public getBankSlip(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {

        return this.make<HttpHook>(HttpHook)
            .pipe(concatMap((httpHook: HttpHook) => {
                return this.settings
                    .pipe(concatMap((settings: any) => {

                        const endpoint = settings.environment == EnvironmentKind.DEV
                            ? 'https://app.local.nickbuilder.com.br/api/process/start/new'
                            : 'https://pay.fluna.io/api/process/start/new';


                        const httpArtifact = new NickProcessArtfact();
                        httpArtifact.kind = ArtfactKind.ANY;
                        httpArtifact.object = {
                            config: {
                                url: `${endpoint}/c9227de0-8b27-4a59-aab8-abb8451d14be`,
                                params: {},
                                headers: {
                                    'nick-system': 'c45606f4-a9c9-48cd-b63f-8c1ddca7c2f8'
                                },
                                body: {
                                    establishmentId: inputArtifact.object.establishmentId,
                                    serviceData: inputArtifact.object.serviceData,
                                    ourNumber: inputArtifact.object.ourNumber
                                }
                            }
                        };

                        return httpHook.postExternal(httpArtifact);
                    }));
            }))
            .pipe(map((response: NickProcessArtfact) => {
                return response;
            }));
    }

    @Hook('f0bb52f4-1017-4d03-aa80-fb2460bd0961')
    public createPix(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.make<HttpHook>(HttpHook)
            .pipe(concatMap((httpHook: HttpHook) => {
                return this.settings
                    .pipe(concatMap((settings: any) => {

                        const endpoint = settings.environment == EnvironmentKind.DEV
                            ? 'https://app.local.nickbuilder.com.br/api/process/start/new'
                            : 'https://pay.fluna.io/api/process/start/new';

                        const customer = inputArtifact.object.customer ? {
                            firstName: inputArtifact.object.customer.firstName,
                            lastName: inputArtifact.object.customer.lastName,
                            email: inputArtifact.object.customer.email,
                            phone: inputArtifact.object.customer.phone,
                            document: inputArtifact.object.customer.document,
                            birthday: inputArtifact.object.customer.birthday,
                            address: {
                                line1: inputArtifact.object.customer.address.line1,
                                line2: inputArtifact.object.customer.address.line2,
                                line3: inputArtifact.object.customer.address.line3,
                                neighborhood: inputArtifact.object.customer.address.neighborhood,
                                city: inputArtifact.object.customer.address.city,
                                state: inputArtifact.object.customer.address.state,
                                postalCode: inputArtifact.object.customer.address.postalCode,
                                countryCode: inputArtifact.object.customer.address.countryCode
                            }
                        } : null;

                        const httpArtifact = new NickProcessArtfact();
                        httpArtifact.kind = ArtfactKind.ANY;
                        httpArtifact.object = {
                            config: {
                                url: `${endpoint}/8384fbb6-95fa-4ef3-b30d-64c0ddc02c82`,
                                params: {},
                                headers: {
                                    'nick-system': 'c45606f4-a9c9-48cd-b63f-8c1ddca7c2f8'
                                },
                                body: {
                                    customer: customer,
                                    establishmentId: inputArtifact.object.establishmentId,
                                    expireAt: inputArtifact.object.expireAt,
                                    description: inputArtifact.object.description,
                                    amount: inputArtifact.object.amount
                                }
                            }
                        };

                        return httpHook.postExternal(httpArtifact);
                    }));
            }))
            .pipe(map((response: NickProcessArtfact) => {
                return response;
            }));
    }

    @Hook('680204b9-9958-4cd1-9c72-a776e240e2d4')
    public getInstallmentValues(artifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const totalAmount = artifact.object.data.totalAmount;
        const installmentCount = artifact.object.data.installmentCount;

        const installmentAmount = parseFloat((totalAmount / installmentCount).toFixed(2));
        const residualInstallmentAmount = parseFloat((totalAmount - (installmentAmount * (installmentCount - 1))).toFixed(2));
        const residualAmount = parseFloat((residualInstallmentAmount - installmentAmount).toFixed(2));

        artifact.object.installmentAmount = installmentAmount;
        artifact.object.residualInstallmentAmount = residualInstallmentAmount;
        artifact.object.residualAmount = residualAmount;

        return of(artifact);
    }

    @Hook('be07ec20-22ab-4e5f-9353-5380000c730f')
    public temp_generateBillList(artifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        // this hook should be deprecated when flow supports these operations
        const billList = [];
        let competenceAt = artifact.object.config.competenceAt;
        let dueAt = artifact.object.config.dueAt;
        for (let i = 0; i < Object.keys(artifact.object.config.installmentList).length; i++) {
            const key = Object.keys(artifact.object.config.installmentList)[i];
            for (let j = 0; j < artifact.object.config.installmentList[key].length; j++) {
                const item = artifact.object.config.installmentList[key][j];
                if (billList[j]) {
                    const bill: any = billList[j];
                    bill.discount = parseFloat((bill.discount + item.discount + item.discountSale + item.discountIndication).toFixed(2));
                    bill.amount = parseFloat((bill.amount + item.amount).toFixed(2));
                    bill.item.push({
                        'name': item.name,
                        'amount': parseFloat(item.amount.toFixed(2)),
                        'discount': parseFloat(item.discount.toFixed(2)),
                        'discountIndication': parseFloat(item.discountIndication.toFixed(2)),
                        'discountSale': parseFloat(item.discountSale.toFixed(2)),
                        'kind': item.kind,
                        'index': item.index
                    });
                    billList[j] = bill;
                } else {
                    billList.push({
                        'amount': parseFloat(item.amount.toFixed(2)),
                        'discount': parseFloat((item.discount + item.discountSale + item.discountIndication).toFixed(2)),
                        'competenceAt': competenceAt,
                        'dueAt': dueAt,
                        'item': [{
                            'name': item.name,
                            'amount': parseFloat(item.amount.toFixed(2)),
                            'discount': parseFloat(item.discount.toFixed(2)),
                            'discountSale': parseFloat(item.discountSale.toFixed(2)),
                            'discountIndication': parseFloat(item.discountIndication.toFixed(2)),
                            'kind': item.kind,
                            'index': item.index
                        }]
                    });
                    competenceAt = moment(competenceAt).add(1, 'months').toDate();
                    dueAt = moment(dueAt).add(1, 'months').toDate();
                }
            }
        }
        artifact.object.data = billList;
        return of(artifact);
    }
}
